export const RQ_NNC_DETAIL_REPORT_API = {
  url: 'merindmarketingactivitymaster/getDetailReport/<%= locationId %>/<%= fromDate %>/<%= toDate %>',
  method: 'GET',
  auth: true,
};

export const RQ_NNC_SUMMARY_REPORT_API = {
  url: 'merindmarketingactivitymaster/getSummaryReport/<%= locationId %>/<%= fromDate %>/<%= toDate %>',
  method: 'GET',
  auth: true,
};

export const RQ_NNC_DASHBOARD_REPORT_API = {
  url: 'merindmarketingactivitymaster/getDashboardReport/<%= locationId %>/<%= fromDate %>/<%= toDate %>',
  method: 'GET',
  auth: true,
};

export const RQ_NNC_REPORTED_DATA_LIST_API = {
  url: 'merindmarketingactivitymaster/getReportedDataList/<%= locationId %>/<%= fromDate %>/<%= toDate %>/<%= nncType %>',
  method: 'GET',
  auth: true,
};
